class SingleNews {
	constructor() {
		if(!document.body.classList.contains("single-news")){
			return;
		}
		resizeCallbacks.push(this);
		this.fixShare();
	}

	fixShare() {
		if (this.fixedShare) {
			this.fixedShare.kill(true);
		}
		if (window.innerWidth > 767) {
			const shareCol = document.querySelector(".share-col");
			this.fixedShare = ScrollTrigger.create({
				trigger: shareCol,
				start: "top 90",
				end: () => `+=${shareCol.clientHeight}`,
				scrub: true,
				anticipatePin: 1,
				pin: ".share-container",
			});
		}
	}

	resize() {
		this.fixShare();
	}
}
